import { render } from "./descriptor.vue?vue&type=template&id=f495626c&scoped=true"
import script from "./descriptor.vue?vue&type=script&lang=js"
export * from "./descriptor.vue?vue&type=script&lang=js"

import "./descriptor.vue?vue&type=style&index=0&id=f495626c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\gurmi\\Projects\\anyform\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f495626c"]])

export default __exports__